import { render, staticRenderFns } from "./TrainingCustomFieldsPrompt.vue?vue&type=template&id=6132f2e4&"
import script from "./TrainingCustomFieldsPrompt.vue?vue&type=script&lang=js&"
export * from "./TrainingCustomFieldsPrompt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports